import './styles.css';
import { useState } from 'react';
import InstallmentBanks from './components/InstallmentBanks';

const WebInstallmentBanks = () => {
  const [activeTab, setActiveTab] = useState('0');
  console.log(activeTab, '-------activeTab');
  return (
    <>
      <section className="bankWebContainer">
        <InstallmentBanks />
      </section>
    </>
  );
};
export default WebInstallmentBanks;
